// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_g3-0";